<div>
  <h6 class="odx-title-6" i18n="@@global.exZones">Ex-Zonen</h6>

  <app-floorplan-menu-item-buttons>
    @for (zoneType of [ExZoneType.ZONE_0, ExZoneType.ZONE_1, ExZoneType.ZONE_2]; track zoneType) {
      <button
        odxButton
        [ngClass]="`ex-${$index}`"
        (click)="addExZone(zoneType)"
        [odxTooltip]="tooltipTextAddExZone($index)"
        [odxTooltipOptions]="{ position: 'bottom-start' }"
        draggable="true"
        (dragstart)="dragExZone(zoneType)"
      >
        <odx-icon name="plus" size="medium"></odx-icon>
      </button>
    }
    <app-toggle-visibility-button
      [visible]="floorplanState.exZonesVisible"
      (toggleEvent)="floorplanState.exZonesVisible = $event"
    >
    </app-toggle-visibility-button>
    <app-toggle-item-text-visibility-button
      [itemTextVisible]="floorplanState.exZonesItemTextVisible"
      (toggleEvent)="updateExZonesItemTextVisibility($event)"
    ></app-toggle-item-text-visibility-button>

    <app-toggle-lock-button [locked]="floorplanState.exZonesLocked" (toggleEvent)="floorplanState.exZonesLocked = $event">
    </app-toggle-lock-button>
  </app-floorplan-menu-item-buttons>
</div>
